import api from './client';

/**
 * Собирает все элементы с пагинированного GET /api/tasks/ (DRF page_size).
 */
export default async function fetchTaskListAllPages(initialPath) {
  const path0 = initialPath && initialPath.startsWith('/') ? initialPath : '/tasks/';
  const out = [];
  let path = path0;
  for (;;) {
    const res = await api.get(path);
    const body = res.data;
    if (Array.isArray(body)) {
      return body;
    }
    const chunk = Array.isArray(body.results) ? body.results : [];
    out.push(...chunk);
    const nextAbs = body.next;
    if (!nextAbs) break;
    const nextPath = drfNextToApiRelativePath(nextAbs);
    if (!nextPath) break;
    path = nextPath;
  }
  return out;
}

function drfNextToApiRelativePath(nextUrl) {
  try {
    const u = new URL(nextUrl, typeof window !== 'undefined' ? window.location.origin : 'http://localhost');
    const p = u.pathname || '';
    const marker = '/api';
    const idx = p.indexOf(marker);
    const rest = idx >= 0 ? p.slice(idx + marker.length) : p;
    const rel = (rest.startsWith('/') ? rest : `/${rest}`) + (u.search || '');
    return rel || null;
  } catch {
    return null;
  }
}
